<template>
  <div id="map">
    <div class="card">
      <div class="card-body">
        <h5 class="mt-0 card-title">
          Localisation
        </h5>
        {{ group.address }}, {{ group.zipcode }} {{ group.city }}<br><br>
        <div style="width: 100%">
          <iframe
            width="100%"
            height="200"
            :src="`https://maps.google.com/maps?width=100%&amp;height=200&amp;hl=en&amp;coord=${group.lat},${group.lng}&amp;q=${group.address} ${group.city}&amp;ie=UTF8&amp;t=p&amp;z=12&amp;iwloc=B&amp;output=embed`"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const name = "GroupMap";

export default {
	name,
	props: {
		group: {
			type: Object,
			required: true
		}
	},
}; 
</script>